import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";

const firebaseConfig = {
  apiKey: "AIzaSyDWHz1IZta-ZvXtTfr9kb018Mfn7ZxXxAc",
  authDomain: "jotavdrone-1dce0.firebaseapp.com",
  projectId: "jotavdrone-1dce0",
  storageBucket: "jotavdrone-1dce0.appspot.com",
  messagingSenderId: "239460897489",
  appId: "1:239460897489:web:f1f9cca46e479466c76bf0",
  measurementId: "G-90P34CPEH9",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);


export default analytics;
